import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "apInputMoney__inner" }
const _hoisted_2 = {
  key: 0,
  class: "apInputMoney__label"
}
const _hoisted_3 = ["value", "placeholder", "disabled"]
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_money3 = _resolveDirective("money3")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['apInputMoney', { 'apInputMoney--error': _ctx.hasErrorText }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['apInputMoney__field', {'apInputMoney__field--border': _ctx.border}])
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "apInputMoney__input",
          value: _ctx.modelValue,
          placeholder: _ctx.placeholder,
          disabled: _ctx.disabled,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
        }, null, 40, _hoisted_3), [
          [_directive_money3, _ctx.money]
        ]),
        (_ctx.currency)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "₸"))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", { class: "apInputMoney__hint" }, _toDisplayString(_ctx.hintOrError), 513), [
          [_vShow, _ctx.hintOrError]
        ])
      ]),
      _: 1
    })
  ], 2))
}